'use client';
import { jsx } from 'react/jsx-runtime';
import { getValidChildren } from '@chakra-ui/utils/children';
import { cloneElement } from 'react';
import { useBreadcrumbStyles } from './breadcrumb-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const BreadcrumbList = forwardRef(
  function BreadcrumbList2(props, ref) {
    const {
      children,
      spacing = "0.5rem",
      separator = "/",
      className,
      ...rest
    } = props;
    const styles = useBreadcrumbStyles();
    const validChildren = getValidChildren(children);
    const count = validChildren.length;
    const clones = validChildren.map(
      (child, index) => cloneElement(child, {
        separator,
        spacing,
        isLastChild: count === index + 1
      })
    );
    return /* @__PURE__ */ jsx(
      chakra.ol,
      {
        ref,
        className: "chakra-breadcrumb__list",
        __css: {
          display: "flex",
          alignItems: "center",
          ...styles.list
        },
        ...rest,
        children: clones
      }
    );
  }
);
BreadcrumbList.displayName = "BreadcrumbList";

export { BreadcrumbList };
